import {TransactionEntryLine} from '@/types/transaction/TransactionEntryLine'

export enum ErrorCode {
    NO_ENTRY_LINES = 'NO_ENTRY_LINES',
    NO_AMOUNT = 'NO_AMOUNT',
    NO_ACCOUNT = 'NO_ACCOUNT',
    NO_SUB_ACCOUNT = 'NO_SUB_ACCOUNT',
    NO_DESCRIPTION = 'NO_DESCRIPTION',
    NO_DEPARTMENT = 'NO_DEPARTMENT',
    NO_PROJECT = 'NO_PROJECT',
    TOO_MANY_SUB_ACCOUNTS = 'TOO_MANY_SUB_ACCOUNTS',
    WRONG_ACCOUNT = 'WRONG_ACCOUNT',
    UNBALANCED = 'UNBALANCED',
    UNKNOW_ERROR = 'UNKNOW_ERROR',
    WRONG_INVOICE_DUE_DATE = 'WRONG_INVOICE_DUE_DATE',
    INVALID_ACCRUAL = 'INVALID_ACCRUAL',
    INVALID_DATE = 'INVALID_DATE',
    INVALID_BANK_ACCOUNT = 'INVALID_BANK_ACCOUNT',
    INVALID_KID = 'INVALID_KID',
    PERIOD_CLOSED = 'PERIOD_CLOSED',
}



export type EntryLineValidationResult = {
    valid : boolean,
    errors : ErrorCode[],
}

export interface EntryLineValidator {
    (entryLines: TransactionEntryLine[]): EntryLineValidationResult
}